import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "course-wrapper"
};
const _hoisted_2 = {
  key: 0,
  class: "course-list"
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  class: "sort"
};
import CourseCard from './CourseCard.vue';
import Empty from 'components/Empty';
export default {
  __name: 'Course',
  props: {
    courseList: {
      type: Array
    },
    pageInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    sortKey: {
      type: String || Number
    }
  },
  emits: ['sort', 'pageChange'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const $emit = __emit;
    const activeName = ref('building');
    const watchType = ref(1);
    const creatType = ref(1); // 1 倒叙 2 正序
    const sortHandle = type => {
      switch (type) {
        case 'view':
          watchType.value = watchType.value == 1 ? 2 : 1;
          $emit('sort', {
            sortType: watchType.value,
            sortKey: 1
          });
          break;
        case 'creatTime':
          creatType.value = creatType.value == 1 ? 2 : 1;
          $emit('sort', {
            sortType: creatType.value,
            sortKey: 2
          });
          break;
        default:
          return;
      }
    };
    const pageChange = e => {
      console.log(e);
      $emit('pageChange', e);
    };
    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
        modelValue: _unref(activeName),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(activeName) ? activeName.value = $event : null),
        onTabClick: _ctx.handleClick
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "全部课程",
          name: "building"
        }, {
          default: _withCtx(() => [__props.courseList && __props.courseList.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.courseList, (item, index) => {
            return _openBlock(), _createBlock(CourseCard, {
              key: item.id,
              courseItem: item,
              index: index
            }, null, 8, ["courseItem", "index"]);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_unref(Empty), {
            type: "course"
          })])), _createVNode(_component_el_pagination, {
            background: "",
            "hide-on-single-page": "",
            onCurrentChange: pageChange,
            "current-page": __props.pageInfo.pageNum,
            "page-size": __props.pageInfo.pageSize,
            layout: "total, prev, pager, next",
            style: {
              "margin-top": "20px",
              "justify-content": "center"
            },
            total: __props.pageInfo.total
          }, null, 8, ["current-page", "page-size", "total"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "onTabClick"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: _normalizeClass(["sort-item view", __props.sortKey == 1 && _unref(watchType) == 1 ? 'asc' : _unref(watchType) == 2 ? 'desc' : '']),
        onClick: _cache[1] || (_cache[1] = $event => sortHandle('view'))
      }, " 查看量 ", 2), _createElementVNode("div", {
        class: _normalizeClass(["sort-item creatTime", __props.sortKey == 2 && _unref(creatType) == 1 ? 'asc' : _unref(creatType) == 2 ? 'desc' : '']),
        onClick: _cache[2] || (_cache[2] = $event => sortHandle('creatTime'))
      }, " 创建时间 ", 2)])]);
    };
  }
};